/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as R404RouteImport } from './routes/404'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as BookingManageRouteImport } from './routes/booking/manage'
import { Route as BookOperatorSlugRouteImport } from './routes/book/$operatorSlug'
import { Route as AuthAuthViewRouteImport } from './routes/auth/$authView'
import { Route as AppSetupRouteImport } from './routes/_app/setup'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppServicesRouteImport } from './routes/_app/services'
import { Route as AppServiceAreaRouteImport } from './routes/_app/service-area'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppLocationsRouteImport } from './routes/_app/locations'
import { Route as AppIntegrationsRouteImport } from './routes/_app/integrations'
import { Route as AppBusinessRouteImport } from './routes/_app/business'
import { Route as AppBookingInfoRouteImport } from './routes/_app/booking-info'
import { Route as AppBillingRouteImport } from './routes/_app/billing'
import { Route as AppAvailabilityRouteImport } from './routes/_app/availability'
import { Route as AppAppointmentsRouteImport } from './routes/_app/appointments'
import { Route as AppAppearanceRouteImport } from './routes/_app/appearance'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as ServicesCatalogIdPreviewRouteImport } from './routes/services/$catalogId/preview'
import { Route as AppAdminUsersRouteImport } from './routes/_app/admin/users'
import { Route as AppAdminSupportRouteImport } from './routes/_app/admin/support'
import { Route as AppAdminEmailsRouteImport } from './routes/_app/admin/emails'
import { Route as AppAdminContentRouteImport } from './routes/_app/admin/content'
import { Route as AppAdminAuditRouteImport } from './routes/_app/admin/audit'
import { Route as AppAdminAnalyticsRouteImport } from './routes/_app/admin/analytics'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const BookingManageRoute = BookingManageRouteImport.update({
  id: '/booking/manage',
  path: '/booking/manage',
  getParentRoute: () => rootRouteImport,
} as any)
const BookOperatorSlugRoute = BookOperatorSlugRouteImport.update({
  id: '/book/$operatorSlug',
  path: '/book/$operatorSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAuthViewRoute = AuthAuthViewRouteImport.update({
  id: '/auth/$authView',
  path: '/auth/$authView',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSetupRoute = AppSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppServicesRoute = AppServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => AppRoute,
} as any)
const AppServiceAreaRoute = AppServiceAreaRouteImport.update({
  id: '/service-area',
  path: '/service-area',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppLocationsRoute = AppLocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => AppRoute,
} as any)
const AppIntegrationsRoute = AppIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppRoute,
} as any)
const AppBusinessRoute = AppBusinessRouteImport.update({
  id: '/business',
  path: '/business',
  getParentRoute: () => AppRoute,
} as any)
const AppBookingInfoRoute = AppBookingInfoRouteImport.update({
  id: '/booking-info',
  path: '/booking-info',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingRoute = AppBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppRoute,
} as any)
const AppAvailabilityRoute = AppAvailabilityRouteImport.update({
  id: '/availability',
  path: '/availability',
  getParentRoute: () => AppRoute,
} as any)
const AppAppointmentsRoute = AppAppointmentsRouteImport.update({
  id: '/appointments',
  path: '/appointments',
  getParentRoute: () => AppRoute,
} as any)
const AppAppearanceRoute = AppAppearanceRouteImport.update({
  id: '/appearance',
  path: '/appearance',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const ServicesCatalogIdPreviewRoute =
  ServicesCatalogIdPreviewRouteImport.update({
    id: '/services/$catalogId/preview',
    path: '/services/$catalogId/preview',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSupportRoute = AppAdminSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminEmailsRoute = AppAdminEmailsRouteImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminContentRoute = AppAdminContentRouteImport.update({
  id: '/content',
  path: '/content',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAuditRoute = AppAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAnalyticsRoute = AppAdminAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AppAdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/404': typeof R404Route
  '/admin': typeof AppAdminRouteWithChildren
  '/appearance': typeof AppAppearanceRoute
  '/appointments': typeof AppAppointmentsRoute
  '/availability': typeof AppAvailabilityRoute
  '/billing': typeof AppBillingRoute
  '/booking-info': typeof AppBookingInfoRoute
  '/business': typeof AppBusinessRoute
  '/integrations': typeof AppIntegrationsRoute
  '/locations': typeof AppLocationsRoute
  '/notifications': typeof AppNotificationsRoute
  '/service-area': typeof AppServiceAreaRoute
  '/services': typeof AppServicesRoute
  '/settings': typeof AppSettingsRoute
  '/setup': typeof AppSetupRoute
  '/auth/$authView': typeof AuthAuthViewRoute
  '/book/$operatorSlug': typeof BookOperatorSlugRoute
  '/booking/manage': typeof BookingManageRoute
  '/': typeof AppIndexRoute
  '/admin/analytics': typeof AppAdminAnalyticsRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/content': typeof AppAdminContentRoute
  '/admin/emails': typeof AppAdminEmailsRoute
  '/admin/support': typeof AppAdminSupportRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/services/$catalogId/preview': typeof ServicesCatalogIdPreviewRoute
  '/admin/': typeof AppAdminIndexRoute
}
export interface FileRoutesByTo {
  '/404': typeof R404Route
  '/appearance': typeof AppAppearanceRoute
  '/appointments': typeof AppAppointmentsRoute
  '/availability': typeof AppAvailabilityRoute
  '/billing': typeof AppBillingRoute
  '/booking-info': typeof AppBookingInfoRoute
  '/business': typeof AppBusinessRoute
  '/integrations': typeof AppIntegrationsRoute
  '/locations': typeof AppLocationsRoute
  '/notifications': typeof AppNotificationsRoute
  '/service-area': typeof AppServiceAreaRoute
  '/services': typeof AppServicesRoute
  '/settings': typeof AppSettingsRoute
  '/setup': typeof AppSetupRoute
  '/auth/$authView': typeof AuthAuthViewRoute
  '/book/$operatorSlug': typeof BookOperatorSlugRoute
  '/booking/manage': typeof BookingManageRoute
  '/': typeof AppIndexRoute
  '/admin/analytics': typeof AppAdminAnalyticsRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/content': typeof AppAdminContentRoute
  '/admin/emails': typeof AppAdminEmailsRoute
  '/admin/support': typeof AppAdminSupportRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/services/$catalogId/preview': typeof ServicesCatalogIdPreviewRoute
  '/admin': typeof AppAdminIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/404': typeof R404Route
  '/_app': typeof AppRouteWithChildren
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/appearance': typeof AppAppearanceRoute
  '/_app/appointments': typeof AppAppointmentsRoute
  '/_app/availability': typeof AppAvailabilityRoute
  '/_app/billing': typeof AppBillingRoute
  '/_app/booking-info': typeof AppBookingInfoRoute
  '/_app/business': typeof AppBusinessRoute
  '/_app/integrations': typeof AppIntegrationsRoute
  '/_app/locations': typeof AppLocationsRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/service-area': typeof AppServiceAreaRoute
  '/_app/services': typeof AppServicesRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/setup': typeof AppSetupRoute
  '/auth/$authView': typeof AuthAuthViewRoute
  '/book/$operatorSlug': typeof BookOperatorSlugRoute
  '/booking/manage': typeof BookingManageRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/analytics': typeof AppAdminAnalyticsRoute
  '/_app/admin/audit': typeof AppAdminAuditRoute
  '/_app/admin/content': typeof AppAdminContentRoute
  '/_app/admin/emails': typeof AppAdminEmailsRoute
  '/_app/admin/support': typeof AppAdminSupportRoute
  '/_app/admin/users': typeof AppAdminUsersRoute
  '/services/$catalogId/preview': typeof ServicesCatalogIdPreviewRoute
  '/_app/admin/': typeof AppAdminIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/404'
    | '/admin'
    | '/appearance'
    | '/appointments'
    | '/availability'
    | '/billing'
    | '/booking-info'
    | '/business'
    | '/integrations'
    | '/locations'
    | '/notifications'
    | '/service-area'
    | '/services'
    | '/settings'
    | '/setup'
    | '/auth/$authView'
    | '/book/$operatorSlug'
    | '/booking/manage'
    | '/'
    | '/admin/analytics'
    | '/admin/audit'
    | '/admin/content'
    | '/admin/emails'
    | '/admin/support'
    | '/admin/users'
    | '/services/$catalogId/preview'
    | '/admin/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/404'
    | '/appearance'
    | '/appointments'
    | '/availability'
    | '/billing'
    | '/booking-info'
    | '/business'
    | '/integrations'
    | '/locations'
    | '/notifications'
    | '/service-area'
    | '/services'
    | '/settings'
    | '/setup'
    | '/auth/$authView'
    | '/book/$operatorSlug'
    | '/booking/manage'
    | '/'
    | '/admin/analytics'
    | '/admin/audit'
    | '/admin/content'
    | '/admin/emails'
    | '/admin/support'
    | '/admin/users'
    | '/services/$catalogId/preview'
    | '/admin'
  id:
    | '__root__'
    | '/404'
    | '/_app'
    | '/_app/admin'
    | '/_app/appearance'
    | '/_app/appointments'
    | '/_app/availability'
    | '/_app/billing'
    | '/_app/booking-info'
    | '/_app/business'
    | '/_app/integrations'
    | '/_app/locations'
    | '/_app/notifications'
    | '/_app/service-area'
    | '/_app/services'
    | '/_app/settings'
    | '/_app/setup'
    | '/auth/$authView'
    | '/book/$operatorSlug'
    | '/booking/manage'
    | '/_app/'
    | '/_app/admin/analytics'
    | '/_app/admin/audit'
    | '/_app/admin/content'
    | '/_app/admin/emails'
    | '/_app/admin/support'
    | '/_app/admin/users'
    | '/services/$catalogId/preview'
    | '/_app/admin/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  R404Route: typeof R404Route
  AppRoute: typeof AppRouteWithChildren
  AuthAuthViewRoute: typeof AuthAuthViewRoute
  BookOperatorSlugRoute: typeof BookOperatorSlugRoute
  BookingManageRoute: typeof BookingManageRoute
  ServicesCatalogIdPreviewRoute: typeof ServicesCatalogIdPreviewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/booking/manage': {
      id: '/booking/manage'
      path: '/booking/manage'
      fullPath: '/booking/manage'
      preLoaderRoute: typeof BookingManageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/book/$operatorSlug': {
      id: '/book/$operatorSlug'
      path: '/book/$operatorSlug'
      fullPath: '/book/$operatorSlug'
      preLoaderRoute: typeof BookOperatorSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/$authView': {
      id: '/auth/$authView'
      path: '/auth/$authView'
      fullPath: '/auth/$authView'
      preLoaderRoute: typeof AuthAuthViewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/setup': {
      id: '/_app/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof AppSetupRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/services': {
      id: '/_app/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof AppServicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/service-area': {
      id: '/_app/service-area'
      path: '/service-area'
      fullPath: '/service-area'
      preLoaderRoute: typeof AppServiceAreaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/locations': {
      id: '/_app/locations'
      path: '/locations'
      fullPath: '/locations'
      preLoaderRoute: typeof AppLocationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/integrations': {
      id: '/_app/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AppIntegrationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/business': {
      id: '/_app/business'
      path: '/business'
      fullPath: '/business'
      preLoaderRoute: typeof AppBusinessRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/booking-info': {
      id: '/_app/booking-info'
      path: '/booking-info'
      fullPath: '/booking-info'
      preLoaderRoute: typeof AppBookingInfoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing': {
      id: '/_app/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AppBillingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/availability': {
      id: '/_app/availability'
      path: '/availability'
      fullPath: '/availability'
      preLoaderRoute: typeof AppAvailabilityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/appointments': {
      id: '/_app/appointments'
      path: '/appointments'
      fullPath: '/appointments'
      preLoaderRoute: typeof AppAppointmentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/appearance': {
      id: '/_app/appearance'
      path: '/appearance'
      fullPath: '/appearance'
      preLoaderRoute: typeof AppAppearanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/services/$catalogId/preview': {
      id: '/services/$catalogId/preview'
      path: '/services/$catalogId/preview'
      fullPath: '/services/$catalogId/preview'
      preLoaderRoute: typeof ServicesCatalogIdPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/admin/users': {
      id: '/_app/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/support': {
      id: '/_app/admin/support'
      path: '/support'
      fullPath: '/admin/support'
      preLoaderRoute: typeof AppAdminSupportRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/emails': {
      id: '/_app/admin/emails'
      path: '/emails'
      fullPath: '/admin/emails'
      preLoaderRoute: typeof AppAdminEmailsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/content': {
      id: '/_app/admin/content'
      path: '/content'
      fullPath: '/admin/content'
      preLoaderRoute: typeof AppAdminContentRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/audit': {
      id: '/_app/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AppAdminAuditRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/analytics': {
      id: '/_app/admin/analytics'
      path: '/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AppAdminAnalyticsRouteImport
      parentRoute: typeof AppAdminRoute
    }
  }
}

interface AppAdminRouteChildren {
  AppAdminAnalyticsRoute: typeof AppAdminAnalyticsRoute
  AppAdminAuditRoute: typeof AppAdminAuditRoute
  AppAdminContentRoute: typeof AppAdminContentRoute
  AppAdminEmailsRoute: typeof AppAdminEmailsRoute
  AppAdminSupportRoute: typeof AppAdminSupportRoute
  AppAdminUsersRoute: typeof AppAdminUsersRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminAnalyticsRoute: AppAdminAnalyticsRoute,
  AppAdminAuditRoute: AppAdminAuditRoute,
  AppAdminContentRoute: AppAdminContentRoute,
  AppAdminEmailsRoute: AppAdminEmailsRoute,
  AppAdminSupportRoute: AppAdminSupportRoute,
  AppAdminUsersRoute: AppAdminUsersRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppAppearanceRoute: typeof AppAppearanceRoute
  AppAppointmentsRoute: typeof AppAppointmentsRoute
  AppAvailabilityRoute: typeof AppAvailabilityRoute
  AppBillingRoute: typeof AppBillingRoute
  AppBookingInfoRoute: typeof AppBookingInfoRoute
  AppBusinessRoute: typeof AppBusinessRoute
  AppIntegrationsRoute: typeof AppIntegrationsRoute
  AppLocationsRoute: typeof AppLocationsRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppServiceAreaRoute: typeof AppServiceAreaRoute
  AppServicesRoute: typeof AppServicesRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppSetupRoute: typeof AppSetupRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRouteWithChildren,
  AppAppearanceRoute: AppAppearanceRoute,
  AppAppointmentsRoute: AppAppointmentsRoute,
  AppAvailabilityRoute: AppAvailabilityRoute,
  AppBillingRoute: AppBillingRoute,
  AppBookingInfoRoute: AppBookingInfoRoute,
  AppBusinessRoute: AppBusinessRoute,
  AppIntegrationsRoute: AppIntegrationsRoute,
  AppLocationsRoute: AppLocationsRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppServiceAreaRoute: AppServiceAreaRoute,
  AppServicesRoute: AppServicesRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppSetupRoute: AppSetupRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  R404Route: R404Route,
  AppRoute: AppRouteWithChildren,
  AuthAuthViewRoute: AuthAuthViewRoute,
  BookOperatorSlugRoute: BookOperatorSlugRoute,
  BookingManageRoute: BookingManageRoute,
  ServicesCatalogIdPreviewRoute: ServicesCatalogIdPreviewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
